import { StyleSheet, TextStyle, ViewStyle } from 'react-native';

function getKeyFromParams<T>(...props: T[]): string {
  let response = '';
  (props.flat() as T[]).forEach((prop) => {
    Object.keys(prop as object).forEach((key) => {
      response += `${key}-${prop[key as keyof T]}-`;
    });
  });

  return response;
}

const memo: {
  [key: string]: {
    [key: string]: ViewStyle | TextStyle;
  };
} = {};

export function getStyleSheet(
  styles: (ViewStyle | TextStyle) | (ViewStyle | TextStyle)[]
) {
  const key = getKeyFromParams<typeof styles>(styles);

  if (!memo[key]) {
    const style = StyleSheet.create({
      [key]: StyleSheet.flatten(styles),
    });

    memo[key] = style;
  }

  const response = memo[key][key];

  return response;
}
